(function () {
  'use strict';

  var motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  function parseSeasonEnd(iso) {
    if (!iso) return NaN;
    var end = Date.parse(String(iso) + 'T23:59:59');
    if (isNaN(end)) end = Date.parse(String(iso));
    return end;
  }

  function pad2(n) {
    return String(Math.max(0, n)).padStart(2, '0');
  }

  function setupCountdown(root) {
    var band = root.querySelector('[data-cc-season-timer]');
    if (!band) return;

    var endIso = band.getAttribute('data-cc-season-end') || '';
    var end = parseSeasonEnd(endIso);
    var units = band.querySelector('[data-cc-timer-units]');
    var ended = band.querySelector('[data-cc-timer-ended]');
    var daysEl = band.querySelector('[data-cc-unit="days"]');
    var hoursEl = band.querySelector('[data-cc-unit="hours"]');
    var minsEl = band.querySelector('[data-cc-unit="mins"]');
    var secsEl = band.querySelector('[data-cc-unit="secs"]');
    var timerId = null;

    function setEnded() {
      band.classList.add('is-ended');
      if (units) units.hidden = true;
      if (ended) ended.hidden = false;
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
    }

    function tick() {
      if (isNaN(end)) {
        setEnded();
        return;
      }
      var ms = end - Date.now();
      if (ms <= 0) {
        setEnded();
        return;
      }
      var totalSecs = Math.floor(ms / 1000);
      var days = Math.floor(totalSecs / 86400);
      var hours = Math.floor((totalSecs % 86400) / 3600);
      var mins = Math.floor((totalSecs % 3600) / 60);
      var secs = totalSecs % 60;
      if (daysEl) daysEl.textContent = pad2(days);
      if (hoursEl) hoursEl.textContent = pad2(hours);
      if (minsEl) minsEl.textContent = pad2(mins);
      if (secsEl) secsEl.textContent = pad2(secs);
      band.classList.remove('is-ended');
      if (units) units.hidden = false;
      if (ended) ended.hidden = true;
    }

    tick();
    if (!band.classList.contains('is-ended')) {
      timerId = setInterval(tick, 1000);
    }
  }

  function setupTypewriter(root) {
    var node = root.querySelector('[data-cc-type]');
    if (!node || motionQuery.matches) return;
    node.classList.add('is-animating');
  }

  function setupApply(root) {
    var form = root.querySelector('[data-cc-apply-form]');
    if (!form) return;

    var steps = Array.from(form.querySelectorAll('[data-cc-step]'));
    var progress = form.querySelector('[data-cc-progress]');
    var stepLabel = form.querySelector('[data-cc-step-label]');
    var stepCount = form.querySelector('[data-cc-step-count]');
    var errorNode = form.querySelector('[data-cc-form-error]');
    var bodyField = form.querySelector('[data-cc-body]');
    var classField = form.querySelector('[data-cc-class-value]');
    var classNameField = form.querySelector('[data-cc-class-name]');
    var classButtons = Array.from(form.querySelectorAll('[data-cc-class]'));
    var backBtn = form.querySelector('[data-cc-back]');
    var nextBtn = form.querySelector('[data-cc-next]');
    var submitBtn = form.querySelector('[data-cc-submit]');
    var pitchHint = form.querySelector('[data-cc-class-hint]');
    var labels = ['Pick your class', 'Your details', 'Your channel', 'Your pitch'];
    var current = 1;
    var selectedClass = 'affiliate';

    function showError(message) {
      if (errorNode) errorNode.textContent = message || '';
    }

    function syncClassUI() {
      classButtons.forEach(function (btn) {
        var value = btn.getAttribute('data-cc-class');
        var selected = value === selectedClass;
        btn.classList.toggle('is-selected', selected);
        btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      if (classField) classField.value = selectedClass === 'creator' ? 'Bronze' : 'The Affiliate';
      if (classNameField) classNameField.value = classField ? classField.value : '';
      if (pitchHint) {
        pitchHint.innerHTML =
          'Applying as <b>' +
          (selectedClass === 'creator' ? 'Bronze' : 'The Affiliate') +
          '</b> — one or two lines is plenty.';
      }
    }

    function stepAt(index) {
      return (
        steps.find(function (step) {
          return Number(step.getAttribute('data-cc-step')) === index;
        }) || null
      );
    }

    function syncNav() {
      if (backBtn) backBtn.hidden = current <= 1;
      if (nextBtn) nextBtn.hidden = current >= 4;
      if (submitBtn) submitBtn.hidden = current < 4;
      if (stepLabel) stepLabel.textContent = labels[current - 1] || '';
      if (stepCount) stepCount.textContent = 'Step ' + current + ' of 4';
      if (progress) progress.style.transform = 'scaleX(' + current / 4 + ')';
    }

    // moveFocus must be false on the initial mount: focusing the step heading on page load drops
    // keyboard and screen-reader users into the middle of the document.
    function showStep(index, moveFocus) {
      current = index;
      steps.forEach(function (step) {
        var active = Number(step.getAttribute('data-cc-step')) === current;
        step.classList.toggle('is-active', active);
        step.hidden = !active;
        Array.from(step.querySelectorAll('input, select, textarea, button')).forEach(function (field) {
          if (field.hasAttribute('data-cc-always-enabled')) return;
          if (field.closest('[data-cc-form-nav]')) return;
          field.disabled = !active;
        });
      });
      // Keep class value + body fields always enabled for submit
      if (classField) classField.disabled = false;
      if (classNameField) classNameField.disabled = false;
      if (bodyField) bodyField.disabled = false;
      Array.from(form.querySelectorAll('[data-cc-always-enabled]')).forEach(function (field) {
        field.disabled = false;
      });
      syncNav();
      showError('');
      if (!moveFocus) return;
      var focusTarget = stepAt(current);
      if (focusTarget) {
        var heading = focusTarget.querySelector('[data-cc-focus]');
        if (heading) heading.focus({ preventScroll: true });
      }
    }

    function fieldValue(selector) {
      var el = form.querySelector(selector);
      return el ? String(el.value || '').trim() : '';
    }

    function validate(step) {
      if (step === 1) {
        if (!selectedClass) return 'Pick a class to continue';
        return '';
      }
      if (step === 2) {
        if (!fieldValue('[data-cc-name]')) return 'Add a name or handle to continue';
        var email = fieldValue('[data-cc-email]');
        if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return 'Add a valid email so we can reply';
        return '';
      }
      if (step === 3) {
        if (!fieldValue('[data-cc-link]')) return 'Add a link to your channel or portfolio';
        return '';
      }
      if (step === 4) {
        if (!fieldValue('[data-cc-pitch]')) return 'Tell us what you would put on a mat';
        return '';
      }
      return '';
    }

    function buildBody() {
      var rows = [
        ['Topic', 'Creator Club application'],
        ['Class', selectedClass === 'creator' ? 'Bronze' : 'The Affiliate'],
        ['Name / handle', fieldValue('[data-cc-name]')],
        ['Email', fieldValue('[data-cc-email]')],
        ['Channel / portfolio', fieldValue('[data-cc-link]')],
        ['Platform', fieldValue('[data-cc-platform]')],
        ['Audience size', fieldValue('[data-cc-audience]')],
        ['Pitch', fieldValue('[data-cc-pitch]')],
      ];
      return rows
        .map(function (row) {
          return row[0] + ': ' + row[1];
        })
        .join('\n');
    }

    classButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        selectedClass = btn.getAttribute('data-cc-class') || 'affiliate';
        syncClassUI();
        showError('');
      });
    });

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        var err = validate(current);
        if (err) {
          showError(err);
          return;
        }
        showStep(Math.min(4, current + 1), true);
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        showStep(Math.max(1, current - 1), true);
      });
    }

    form.addEventListener('submit', function (event) {
      var err = validate(4);
      if (err) {
        event.preventDefault();
        showError(err);
        showStep(4, true);
        return;
      }
      // Re-enable every field so Shopify receives the full payload
      Array.from(form.querySelectorAll('input, select, textarea, button')).forEach(function (field) {
        field.disabled = false;
      });
      if (bodyField) bodyField.value = buildBody();
      syncClassUI();
    });

    // Enable name/email for Shopify contact form always when on their steps
    Array.from(form.querySelectorAll('[data-cc-name], [data-cc-email], [data-cc-link], [data-cc-platform], [data-cc-audience], [data-cc-pitch]')).forEach(
      function (field) {
        field.setAttribute('data-cc-field', '');
      }
    );

    syncClassUI();
    showStep(1);
  }

  function init(root) {
    if (!root || root.getAttribute('data-cc-ready') === 'true') return;
    root.setAttribute('data-cc-ready', 'true');
    setupCountdown(root);
    setupTypewriter(root);
    setupApply(root);
  }

  function boot() {
    Array.from(document.querySelectorAll('[data-creator-club-season]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector
      ? event.target.querySelector('[data-creator-club-season]')
      : null;
    if (root) {
      root.removeAttribute('data-cc-ready');
      init(root);
    }
  });
})();
